<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ชื่อสินค้า:</label> 
                 
                <select2
                            id="odMaterialCode"
                            name="odMaterialCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="odMaterialCodeOptions"
                            v-model="odMaterialCode"
                            ref="odMaterialCodeSelect2"
                            @selectChange="onMaterialCodeChange"
                          ></select2>
                          <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label-required">เจ้าของทรัพย์สิน :</label> 
                  <select2
                            id="mbAssetOwnerId"
                            name="mbAssetOwnerId"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="MbAssetOwnerOptions"
                            v-model="mbAssetOwnerId"
                            ref="mbAssetOwnerIdSelect2"
                            @selectChange="onMbAssetOwnerIdChange"
                          ></select2>
                    <span class="form-text"></span>
 
                </div>
              </div>
            <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6"></div> -->

            
          </div> 

          <div class="row">  
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ปี(สินค้า) (ค.ศ.) :</label>
                <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(YYYY)"
                      id="odYear"
                      name="odYear"
                      ref="odYear"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ราคาค่าถัง (<span class="text-danger">* ราคาใช้สำหรับรายงานคงค้างเกินกำหนด</span>) :</label>
                <input
                            id="odPrice"
                            name="odPrice"
                            v-model="odPrice"
                            type="number" min="0.00"  
                            class="form-control"
                            placeholder="บาท"
                          /> 
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6"></div> 
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">วันที่บันทึก :</label>
                <div class="input-group date">
                      <input style="background-color: #EEEEEE;"
                        readonly
                        type="text"
                        class="form-control"
                        placeholder="(วว/ดด/ปปปป)"
                        id="odEffectiveDateFrom"
                        name="odEffectiveDateFrom"
                        ref="odEffectiveDateFrom" 
                      />
                      <!-- <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="la la-calendar-check-o"></i>
                        </span>
                      </div> -->
                      <span class="form-text"></span>
                    </div>
              </div>
            </div>
            <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">วันที่มีผล สิ้นสุด:</label>
                <div class="input-group date">
                      <input
                        readonly
                        type="text"
                        class="form-control"
                        placeholder="(วว/ดด/ปปปป)"
                        id="odEffectiveDateTo"
                        name="odEffectiveDateTo"
                        ref="odEffectiveDateTo" 
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="la la-calendar-check-o"></i>
                        </span>
                      </div>
                      <span class="form-text"></span>
                    </div>
              </div>
            </div> -->
          </div>

          <!-- Begin:InActiveStatus element -->
          <div class="row">
            <div class="col-xl-2">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="odInActiveStatus"
                      name="odInActiveStatus"
                      v-model="odInActiveStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- End:InActiveStatus element -->
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>


<script>
import axios from "axios";
import select2 from "../../../Shared/Select2"; 
import datepicker from "../../../Shared/Datepicker";
import plupload from "plupload";
import Vue from "vue"; 

export default {
  components: {
    select2,
  }, 
  data: function() {
    var self = this;
    return {
      mbAssetOwnerName : null,
      odMaterialName: null, 
      odMaterialCode:null,
      odYear:null,
      odEffectiveDateFrom:null,
      odEffectiveDateTo:null,
      odPrice : null,
      odInActiveStatus : true, 
      odMaterialCodeOptions: [],
      mbAssetOwnerId : null,
      MbAssetOwnerOptions: [],

      MbAssetOwnerOptions : {
        placeholder: "เลือกเจ้าของทรัพย์สิน ",
        allowClear: true,
        ajax: {
          url: "/Api/assetOwner/Select2SearchAssetOwner",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1, 
              onlyHasBarcode: true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      odMaterialCodeOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1, 
              onlyHasBarcode: true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 

    };
  },
  methods: {
    formSubmit: function(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      axios
            .post("/Api/MasterProductUnitPrice/ValidateDate", {  
            Id:this.$route.params.id, 
            odMaterialCode:this.odMaterialCode, 
            mbAssetOwnerId : this.mbAssetOwnerId,
            odYear: self.odYear != null
                    ? self.odYear.format("YYYY")
                    : self.odYear 
            })
            .then(function(response) {
              
              if(response.data != null && response.data != "" && self.odInActiveStatus){ 
                // มีข้อมูลอยู่แล้ว
                console.log(response);
                var product = response.data.materialcode + " "+ response.data.materialdesC_TH2 ;
                Swal.fire({
                  title: "แจ้งเตือน",
                  html: "ปี : " + response.data.year +"<br> สินค้า : " +product + "<br> เจ้าของทรัพย์สิน :" +response.data.assetOwnerName + " <br> มีการกำหนดราคาไว้แล้วคือราคา "+response.data.unitPrice +" <br> ถ้าหากบันทึกใหม่ระบบจะปิดการใช้งานรายการเดิมและบันทึกรายการใหม่ให้แทน<br>หากต้องการใช้งานราคาใหม่กรุณากดยืนยัน ",
                  icon: "warning",
                  showCancelButton: true,
                  //confirmButtonColor: "#3085d6",
                  //cancelButtonColor: "#d33",
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ยกเลิก",
                }).then((result) => { 
                  if (result.value) {
                    self.SaveChange();
                  }
                  else{ 
                  }
                });

              }
              else{ 
                 self.SaveChange();
              } 
            })
            .catch(function(error) {
              console.log(error);
              Swal.fire("เกิดข้อผิดพลาด", "ERR", "error");
            })
            .then(function() { 
              KTApp.unblockPage();
            }); 


      
    },
    onMbAssetOwnerIdChange: function(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.mbAssetOwnerName = data[0].text;
      } 
    }, 
    onMaterialCodeChange: function(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odMaterialName = data[0].text;
      } 
    },
    odTranTypeCodeChange: function(id, text, data, ref) {
       //nothing
       var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odTranTypeName = data[0].text;
      } 
    }, 
    SaveChange(){
      let self = this; 
      let router = this.$router;
      axios
      .put("/Api/MasterProductUnitPrice", {    
          Id: this.$route.params.id,
          mbAssetOwnerId : this.mbAssetOwnerId,
          mbAssetOwnerName : this.mbAssetOwnerName,
          odMaterialName: this.odMaterialName, 
          odMaterialCode:this.odMaterialCode,
          odTranTypeCode:this.odTranTypeCode,
          odYear: self.odYear != null
                  ? self.odYear.format("YYYY")
                  : self.odYear,
          odPrice : this.odPrice ,
          odEffectiveDateFrom: self.odEffectiveDateFrom ,
          // self.odEffectiveDateFrom != null
          //         ? self.odEffectiveDateFrom.format("DD/MM/YYYY")
          //         : self.odEffectiveDateFrom, 
          // odEffectiveDateTo:
          // self.odEffectiveDateTo != null
          //         ? self.odEffectiveDateTo.format("DD/MM/YYYY")
          //         : self.odEffectiveDateTo, 
  
          odInActiveStatus : !this.odInActiveStatus,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });

    },
    ConfigDate() 
    { 
     
      let self = this; 
      var arrows;
      // set validation rules
      if (KTUtil.isRTL()) {
        arrows = {
          leftArrow: '<i class="la la-angle-right"></i>',
          rightArrow: '<i class="la la-angle-left"></i>',
        };
      } else {
        arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
        };
      }

      let y = moment().year();
      if(self.odYear!=null){
        y = parseInt(self.odYear.format("YYYY"));
      }
        
 /*
      $(self.$refs.odEffectiveDateFrom).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      // startDate : "01/01/"+y,
      // endDate:"31/12/"+y,
      //endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: self.arrows,
      });
      $(self.$refs.odEffectiveDateFrom)
      .datepicker(
        "update",
        !!self.odEffectiveDateFrom ? self.odEffectiveDateFrom.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.odEffectiveDateFrom = e.dates.length != 0 ? moment(e.date) : null;
      }); 

      $(self.$refs.odEffectiveDateTo).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(), 
      // startDate : "01/01/"+y,
      // endDate:"31/12/"+y,
      //endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: self.arrows,
      });
      $(self.$refs.odEffectiveDateTo)
      .datepicker(
        "update",
        !!self.odEffectiveDateTo ? self.odEffectiveDateTo.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.odEffectiveDateTo = e.dates.length != 0 ? moment(e.date) : null;
      });  

      */

    }

  },

  async mounted() {
    let self = this;
    let router = this.$router; 
    let user = await this.$root.getUser();
    
    var arrows;
      // set validation rules
      if (KTUtil.isRTL()) {
        arrows = {
          leftArrow: '<i class="la la-angle-right"></i>',
          rightArrow: '<i class="la la-angle-left"></i>',
        };
      } else {
        arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
        };
      } 

    $(this.$refs.form).validate({
 
      rules: {
        odMaterialCode: "required", 
        odYear:"required",  
        odPrice: "required",
      //  odEffectiveDateFrom: "required",
      //  odEffectiveDateTo: "required",
        
      },
      messages: { 
        odMaterialCode: "กรุณาเลือกชื่อสินค้า", 
        odYear:"กรุณาเลือกปี (ค.ศ.)",  
        odPrice : "กรุณากรอกจำนวนเงินราคาค่าถัง", 
      //  odEffectiveDateFrom : "กรุณากรอก Effective From", 
     //   odEffectiveDateTo : "กรุณากรอกจำนวนเงินราคาค่าถัง", 
      },
    });

    self.ConfigDate();
    
      $(self.$refs.odYear).datepicker({
      format: "yyyy",
      viewMode: "years",
      minViewMode: "years",
      autoclose: true,
      clearBtn: true,
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      templates: arrows,
    });
    $(self.$refs.odYear).datepicker(
      "update",
      !!self.odYear ? self.odYear.format("YYYY") : null
    ).on("changeDate", function(e) {
      self.odYear = e.dates.length != 0 ? moment(e.date) : null;
       
    });
    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/MasterProductUnitPrice/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) { 
          
            
            self.odEffectiveDateFrom = moment( response.data.effectiveDateStart).format("DD/MM/YYYY");
            $("#odEffectiveDateFrom").val(moment( response.data.effectiveDateStart).format("DD/MM/YYYY"));
           // self.odEffectiveDateTo = moment( response.data.effectiveDateEnd);

            self.odInActiveStatus = !response.data.inActiveStatus;
            self.odYear = moment(response.data.year+"-01-01");
            self.odPrice = response.data.unitPrice;
             
            // $(self.$refs.odEffectiveDateFrom)
            // .datepicker(
            //   "update",
            //   !!self.odEffectiveDateFrom ? self.odEffectiveDateFrom.format("DD/MM/YYYY") : null
            // )
            // .on("changeDate", function(e) {
            //   self.odEffectiveDateFrom = e.dates.length != 0 ? moment(e.date) : null;
            // });

            // $(self.$refs.odEffectiveDateTo)
            // .datepicker(
            //   "update",
            //   !!self.odEffectiveDateTo ? self.odEffectiveDateTo.format("DD/MM/YYYY") : null
            // )
            // .on("changeDate", function(e) {
            //   self.odEffectiveDateTo = e.dates.length != 0 ? moment(e.date) : null;
            // });

            $(self.$refs.odYear).datepicker(
              "update",
              !!self.odYear ? self.odYear.format("YYYY") : null
            ).on("changeDate", function(e) {
              self.odYear = e.dates.length != 0 ? moment(e.date) : null;
              
            });

            if (response.data.assetOwnerId) {
              self.$refs.mbAssetOwnerIdSelect2.setSelectedData({
                id: response.data.assetOwnerId,
                text: response.data.assetOwnerName,
              });
            } 

            
            if (response.data.materialcode) {
              self.$refs.odMaterialCodeSelect2.setSelectedData({
                id: response.data.materialcode,
                text: response.data.materialdesC_TH2 + " ["+response.data.materialcode+"]",
              });
            } 
 
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

  },
 
};
</script>
<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-plant {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1.2rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/MasterProductUnitPrice/MasterProductUnitPriceUpdate.vue